import $ from "jquery";
import { gsap, Power2 } from "gsap";
require("magnific-popup");

require("../../../vendor/royalslider/jquery.royalslider.min");

const overlay = $("#overlay");
const modal = document.querySelector("#public-vote-modal");

const likeBtnSelector = ".js-work-like-btn";
// При наведении (клике) по сердечку появляется визуальный эффект
const likeBtnBackSelector = ".js-btn-like-back"; // В общем это визуальный эффект, а не возврат лайка
const likeBtnActiveClass = "btn-like_active";

const $authPopup = $("#auth-popup");
const $authPopupForm = $authPopup.find("form");
const $notification = $(".js-work-like-notification");

let closeTitle = "закрыть";

let $btn;
let smartTokenValue;
let url;
let $count;

function initModalClose() {
  overlay?.on("click", function () {
    if (modal?.classList.contains("active")) {
      modal.classList.remove("active");
      $(this).fadeOut();
    }
  });
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  const results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function showWorkVoteInfoBlock(html) {
  const inner = document.querySelector(".js-work-like-info-block-inner");
  const block = document.getElementById("infoBlock");
  if (!inner || !block || !html) {
    return false;
  }
  inner.innerHTML = html;
  if (window.getComputedStyle(block).display === "none") {
    block.style.display = "block";
    window.setTimeout(function () {
      block.style.opacity = "1";
    }, 10);
    block.scrollIntoView({ behavior: "smooth", block: "nearest" });
    window.setTimeout(function () {
      block.style.opacity = "0";
      window.setTimeout(function () {
        block.style.display = "none";
        inner.innerHTML = "";
      }, 500);
    }, 5000);
  }
  return true;
}

function showPublicVotePeriodNotice(wrapEl) {
  if (!wrapEl) {
    return false;
  }

  const period = wrapEl.getAttribute("data-public-vote-period");
  if (period !== "before" && period !== "after") {
    return false;
  }

  const template = document.getElementById("work-vote-like-info-" + period);
  const html = template ? template.innerHTML.trim() : "";
  if (!html) {
    return false;
  }

  const isIframeVote = wrapEl.getAttribute("data-iframe-public-vote") === "1";
  if (!isIframeVote && showWorkVoteInfoBlock(html)) {
    return true;
  }

  openVoteLikeInfoFallback(html);
  return true;
}

function openVoteLikeInfoFallback(html) {
  const wrapped =
    '<div class="tooltip-popup vote-like-tooltip-popup"><div class="tooltip-popup__content">' +
    html +
    '</div><div class="tooltip-popup__close-wrap"><button type="button" class="js-tooltip-popup-close btn btn_outline">' +
    closeTitle +
    "</button></div></div>";

  $.magnificPopup.open({
    mainClass: "tooltip-popup-wrap",
    items: {
      src: wrapped,
      type: "inline",
    },
  });
}

function sendLikeData(token) {
  const postData = {
    "smart-token": token,
  };
  const iframeLikes = document.querySelector(
    '.js-work-likes[data-iframe-public-vote="1"]'
  );
  if (iframeLikes) {
    const ft = window.sessionStorage.getItem("framePublicVoteToken");
    if (ft) {
      postData["frame_public_vote_token"] = ft;
    }
  }

  overlay.fadeOut();
  if (modal) {
    modal.classList.remove("active");
  }

  $.post(
    url,
    postData,
    function (data) {
      if (data.status === "error" && data.info_block && data.html) {
        if (!iframeLikes && showWorkVoteInfoBlock(data.html)) {
          return;
        }
        openVoteLikeInfoFallback(data.html);
        return;
      }

      if (data.status === "ok") {
        if (data.action === "added") {
          $btn.addClass(likeBtnActiveClass);
          $(".like-image").attr("src", "/img/icons/heart-active.svg");
        } else {
          $btn.removeClass(likeBtnActiveClass);
          $(".like-image").attr("src", "/img/icons/heart-red.svg");
        }

        $count = $btn.closest(".js-work-like").find(".js-work-like-count");
        let count = $(".js-work-like-count");

        count.text(data.count);

        if (data.hasOwnProperty("html") && $notification.length && $notification[0]) {
          $notification.html(data.html);

          gsap.set($notification[0], { height: "auto" });
          gsap.from($notification[0], { height: 0 });
        }
      }

      if (data.status === "error" && data.hasOwnProperty("auth")) {
        if (iframeLikes) {
          if (typeof window.__framePublicVoteAuthOpen === "function") {
            window.__framePublicVoteAuthOpen();
          } else {
            const m = document.getElementById("frame-public-vote-auth");
            if (m) {
              m.classList.remove("hidden");
              m.setAttribute("aria-hidden", "false");
            }
          }
        } else {
          $.magnificPopup.open({
            mainClass: "auth-popup-wrap",
            items: {
              src: "#auth-popup",
              type: "inline",
            },
          });
        }
      }

      if (data.status === "error" && data.hasOwnProperty("popup")) {
        const title = data.popup.title;
        const content = data.popup.content;

        let html = '<div class="tooltip-popup">';

        if (title) {
          html += '<div class="tooltip-popup__header">';

          html += '<div class="tooltip-popup__title">' + title + "</div>";
          html += "<hr>";

          html += "</div>"; //.tooltip-popup__header
        }

        html += '<div class="tooltip-popup__content">' + content + "</div>";
        html +=
          '<div class="tooltip-popup__close-wrap"><button class="js-tooltip-popup-close btn btn_outline" type="button">' +
          closeTitle +
          "</button></div>";
        html += "</div>";

        $.magnificPopup.open({
          mainClass: "tooltip-popup-wrap",
          items: {
            src: html,
            type: "inline",
          },
        });
      }
    },
    "json"
  );
}

/**
 * smartCaptcha.js подключается с defer — при первом клике API может быть ещё undefined.
 * Ждём появления window.smartCaptcha, иначе при data-skip-like-captcha уходим без капчи.
 */
function showCaptchaInModal(attempt) {
  const n = attempt || 0;
  const captchaContainer = document.querySelector("#captcha-container");
  if (!captchaContainer || !modal) {
    return;
  }

  if (typeof window.smartCaptcha === "undefined" || !window.smartCaptcha.render) {
    if (n < 100) {
      window.setTimeout(function () {
        showCaptchaInModal(n + 1);
      }, 100);
    } else {
      const wrap = document.querySelector(".js-work-likes");
      if (wrap && wrap.getAttribute("data-skip-like-captcha") === "1") {
        sendLikeData("");
      }
    }
    return;
  }

  const sitekey = captchaContainer.getAttribute("data-sitekey");
  if (!sitekey) {
    return;
  }

  const widgetId = window.smartCaptcha.render(captchaContainer, {
    invisible: false,
    sitekey: sitekey,
  });

  window.smartCaptcha.subscribe(widgetId, "success", sendLikeData);

  overlay.fadeIn();
  modal.classList.add("active");
}

function playLikeBtnBackAnimation($btn) {
  const $btnBack = $btn.find(likeBtnBackSelector);
  if (!$btnBack.length) {
    return;
  }

  const tl = gsap.timeline({ repeat: 1 });

  tl.fromTo(
    $btnBack[0],
    {
      scale: 1,
      autoAlpha: 1,
    },
    {
      scale: 1.6,
      transformOrigin: "50% 50%",
      autoAlpha: 0,
      ease: Power2.easeOut,
      duration: 0.8,
    }
  );
}

function initWorkLike() {
  const $wrap = $(".js-work-likes");
  const authButton = $(".launch-auth");

  if (!$wrap.length) return;

  initModalClose();

  authButton.on("click", async (e) => {
    e.preventDefault();

    $.magnificPopup.open({
      mainClass: "auth-popup-wrap",
      items: {
        src: "#auth-popup",
        type: "inline",
      },
    });
  });

  $wrap.on("click", likeBtnSelector, async function (e) {
    e.preventDefault();

    if (showPublicVotePeriodNotice($wrap[0])) {
      return;
    }

    $btn = $(this);
    playLikeBtnBackAnimation($btn);

    url = $btn.data("url");
    if ($wrap[0] && $wrap[0].getAttribute("data-skip-like-captcha") === "1") {
      sendLikeData("");
    } else {
      showCaptchaInModal();
    }

    const workId = $btn.data("id");

    if ($authPopupForm.find('[name="referer_action"]').length) {
      $authPopupForm.find('[name="referer_action"]').val("contest.work.like");
    } else {
      $authPopupForm.append(
        $("<input />").attr({
          type: "hidden",
          name: "referer_action",
          value: "contest.work.like",
        })
      );
    }

    if ($authPopupForm.find('[name="work_id"]').length) {
      $authPopupForm.find('[name="work_id"]').val(workId);
    } else {
      $authPopupForm.append(
        $("<input />").attr({
          type: "hidden",
          name: "work_id",
          value: workId,
        })
      );
    }
  });

  $wrap.on("mouseenter", likeBtnSelector, function () {
    playLikeBtnBackAnimation($(this));
  });

  $(document).on("click", ".js-auth-popup-close", function (e) {
    e.preventDefault();

    $.magnificPopup.close();
  });

  $(document).on("click", ".js-tooltip-popup-close", function (e) {
    e.preventDefault();

    $.magnificPopup.close();
  });

  //check work id in the url

  const workId = getUrlParameter("contest.work.like");
  if (workId) {
    $wrap.find("[data-id=" + workId + "]").trigger("click");
  }

  // VK-iframe: без сессии модалка подтверждения email при заходе на работу
  if ($wrap[0] && $wrap[0].getAttribute("data-open-frame-vote-auth-on-load") === "1") {
    let storedToken;
    try {
      storedToken = window.sessionStorage.getItem("framePublicVoteToken");
    } catch (e) {
      storedToken = null;
    }
    if (!storedToken) {
      let openAttempts = 0;
      const runOpen = () => {
        if (typeof window.__framePublicVoteAuthOpen === "function") {
          window.__framePublicVoteAuthOpen();
        } else if (openAttempts < 30) {
          openAttempts += 1;
          window.setTimeout(runOpen, 0);
        }
      };
      runOpen();
    }
  }
}

function initWorkRoyalSlider() {
  const selector = ".js-work-royal-slider";

  const $slider = $(selector);

  if (!$slider.length) return;

  let options = {
    autoScaleSlider: true,
    autoScaleSliderWidth: 16,
    autoScaleSliderHeight: 9,
    controlNavigation: "thumbnails",
    keyboardNavEnabled: true,
    fullscreen: {
      enabled: true,
    },
    video: {
      autoHideBlocks: true,
      autoHideArrows: false,
    },
  };

  const mql = window.matchMedia("(max-width: 500px)");
  if (mql.matches) {
    options.autoScaleSliderHeight = 16;
  }

  $slider.royalSlider(options);
}

export { initWorkLike, initWorkRoyalSlider };
